module.exports = __webpack_public_path__ + "static/media/ar.af37f8a3.svg";